export function getJsonData(url, consumer, errorConsumer) {
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(response.status.toString())
    }
  })
  .then(consumer)
  .catch(errorConsumer || console.log);
}

export function postJsonData(url, body, onSuccess, errorConsumer) {
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body ? JSON.stringify(body) : null
  })
  .then(response => {
    if (response.ok) {
      if (onSuccess) {
        onSuccess();
      }
    } else {
      throw new Error(response.status.toString())
    }
  })
  .catch(errorConsumer || console.log);
}

export function postJsonDataAndGetResponse(url, body, consumer, errorConsumer) {
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body ? JSON.stringify(body) : null
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(response.status.toString())
      }
    })
    .then(response => {
      if (consumer) {
        consumer(response);
      }
    })
    .catch(errorConsumer || console.log);
}

export function deleteData(url, onSuccess, errorConsumer) {
  fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (response.ok) {
        if (onSuccess) {
          onSuccess();
        }
      } else {
        throw new Error(response.status.toString())
      }
    })
    .catch(errorConsumer || console.log);
}